module.exports = __webpack_public_path__ + "static/media/my_bcg.5f428310.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/my_bcg.png
// module id = 937
// module chunks = 0